import { graphql } from "gql.tada";

import ImageConnectionFragment from "./imageConnectionFragment";
import MenuFragment from "./menuFragment";
import RestaurantCuisineFragment from "./restaurantCuisineFragment";
import RestaurantLocationFragment from "./restaurantLocation";
import RestaurantTagFragment from "./restaurantTag";

const RestaurantFragment = graphql(
  `
    fragment RestaurantFragment on Restaurant {
      __typename
      id
      regionId
      configurationJSON
      walkInArrivalWindowMinutes
      siteId
      countryCode
      firstTableSessionTypes
      regularTableSessionTypes
      walkInSessionTypes
      title
      menuTitle
      rating
      reviewsCount
      approvedReviewsCount
      ratingSummaries {
        title
        average
        total
        count
      }
      reviewSummary
      reviewSummaryDetails
      acceptsAmex
      bookingPricesBySession {
        __typename
        title
        price
        rrp
        isSpecial
        dinerPrices {
          pax
          price
          rrp
        }
      }
      walkInBookingPricesBySession {
        __typename
        title
        price
        rrp
        isSpecial
        dinerPrices {
          pax
          price
          rrp
        }
      }
      showBookingPriceLabel
      regionRanking
      specialConditions
      isNew
      featuredText
      timeZone
      status
      onHoldText
      additionalPeopleAllowed
      additionalPeopleForbidden
      dinerOptions
      minDiners
      maxDiners
      maxDinnerSlots
      lat
      lng
      street
      city
      cityId
      website
      phone
      openHours
      absoluteLink
      facebook
      instagram
      tiktok
      content
      menuLink
      bookingPrice
      currency
      reviewBoostPlatform
      reviewBoostURL
      bookingWindowDays
      offersFirstTable
      offersRegularTable
      potentialPoints {
        __typename
        key
        value
      }
      slug
      suburb {
        ...RestaurantLocationFragment
      }
      region {
        ...RestaurantLocationFragment
      }
      tags {
        edges {
          node {
            ...RestaurantTagFragment
          }
        }
      }
      cuisines {
        edges {
          node {
            ...RestaurantCuisineFragment
          }
        }
      }
      gallery
      images {
        ...ImageConnectionFragment
      }
      menus {
        edges {
          node {
            ...MenuFragment
          }
        }
      }
      availabilitySessions: sessionTypes
      sessionTypes
      askForDietaryRequirements
    }
  `,
  [
    RestaurantLocationFragment,
    RestaurantTagFragment,
    RestaurantCuisineFragment,
    ImageConnectionFragment,
    MenuFragment,
  ],
);

export default RestaurantFragment;
